module.exports = __webpack_public_path__ + "img/h4.5af9d415.svg";